import React, { useEffect } from 'react'
import Job from './Job';
import { useDispatch, useSelector } from "react-redux";
import { fetchJobs } from "../../features/job/jobSlice";
import { searchedByTitle, sortedBySalary } from '../../features/filters/filterSlice';

function Jobs() {
  //Variables
  const dispatch = useDispatch();
  const { jobs, isLoading, isError } = useSelector(
    (state) => state.job
  );
  const { salary, title, type } = useSelector((state) => state.filters);

  //Hooks
  useEffect(() => {
    dispatch(fetchJobs());
  }, [dispatch]);

  //Functions
  const handleSortBySalary = (sortStatus) => {
    dispatch(sortedBySalary(sortStatus));
  };

  const handleSearchyTitle = (title) => {
    dispatch(searchedByTitle(title))
  };
  const sortedJobs = [...jobs].sort((a, b) => {
    if (salary === 'ASC') {
      return a.salary - b.salary;
    } else if (salary === 'DESC') {
      return b.salary - a.salary;
    } else if (salary === 'default') {
      return 0;
    }
  });


  const searchByTitle = (job) => {
    if (title?.length > 0) {
      return (job?.title).toLowerCase().includes(title.toLowerCase());
    }
    return true;
  };

  const filterByType = ({ type: jobType }) => {
    if (jobType === type) {
      return true
    } else if (type === 'all') {
      return true
    }
  };

  // decide what to render
  let content = null;
  if (isLoading) content = <p>Loading...</p>;

  if (!isLoading && isError)
    content = <p className="error">There was an error occured</p>;

  if (!isLoading && !isError && jobs?.length > 0) {
    content = sortedJobs.filter(filterByType).filter(searchByTitle).map((job) => (
      <Job key={job.id} job={job} />
    ));
  }

  if (!isLoading && !isError && jobs?.length === 0) {
    content = <p>No job found!</p>;
  }

  //JSX
  return (
    <div className="lg:pl-[14rem]  mt-[5.8125rem]">
      <main className="max-w-3xl rounded-lg  mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B]">
        <div className="md:flex space-y-2 md:space-y-0 justify-between mb-10 ">
          <h1 className="lws-section-title">All Available Jobs</h1>
          <div className="flex gap-4">
            <div className="search-field group flex-1">
              <i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500"></i>
              <input type="text" placeholder="Search Job" className="search-input" id="lws-searchJob" onChange={(e) => handleSearchyTitle(e.target.value)} />
            </div>
            <select id="lws-sort" name="sort" autoComplete="sort" className="flex-1" onClick={(e) => handleSortBySalary(e.target.value)}>
              <option value="deafult">Default</option>
              <option value="ASC">Salary (Low to High)</option>
              <option value="DESC">Salary (High to Low)</option>
            </select>
          </div>
        </div>

        <div className="jobs-list">
          {content}
        </div>
      </main>
    </div>
  )
}

export default Jobs